import { BodyText, HeadingText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c12d274z";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const BaseState = ({
  heading,
  description,
  ctaButton,
  imgSrc,
  imgAltText
}) => <Container>
    {imgSrc && <img src={imgSrc} alt={imgAltText || ''} />}
    <HeadingText level={3} size="large">{heading}</HeadingText>
    <BodyText color="muted">{description}</BodyText>
    {ctaButton}
  </Container>;

require("./base_state.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./base_state.js");